<template>
  <div class="row d-flex justify-content-center">
    <div class="col-md-6">
      <div class="mb-4 text-center">
        <h4>{{'Enter payment card details' | translate}}</h4>
      </div>
      <CardForm show-component="true" :public-rsa-prop="publicRsaProp" />

      <div class="d-grid mt-2">
        <button @click="submit" class="btn btn-dark" :disabled="loading">
          {{ 'Confirm and pay' | translate }}
        </button>
      </div>

      <div v-if="has(errors, 'cypher')" class="text-danger mb-4">
        {{'Card data is not valid' | translate}}
      </div>
      <div v-if="has(errors, 'sale')" class="text-danger mb-4">
        {{errors.sale[0] | translate}}
      </div>
      <div v-if="has(errors, 'membership')" class="text-danger mb-4">
        {{errors.membership[0] | translate}}
      </div>
      <div class="small mt-3">
        {{'When you update your card details, the system will collect the payment' | translate}}.
        {{'Thus extending access to the platform' | translate}}.
      </div>
    </div>
  </div>
</template>

<script>
import CardForm from '~/checkout/components/membership/CardForm.vue'
import _ from 'lodash'

export default {
  components: {
    CardForm,
  },
  props: ['publicRsaProp'],
  data: () => ({
    errors: {},
    loading: false,
  }),
  methods: {
    has: _.has,
    submit() {
      this.loading = true
      axios
        .post('/my/membership/card', {
          cypher: this.cypher,
        })
        .then(({ data }) => {
          if (data.redirect) {
            window.location.href = data.redirect
          }
        })
        .catch((error) => {
          this.loading = false
          this.errors = _.get(error, 'response.data.errors')
        })
    },
  },
  computed: {
    cypher() {
      return this.$store.state.cypher
    },
  },
}
</script>

<style></style>
